import { ApiCore } from '@/services/api/utils/core.js'

const url = 'status'
const plural = 'statuses'
const single = 'status'

const api = new ApiCore({
	index: true,
	url: url,
	plural: plural,
	single: single
})

export default api
